
import CookieBanner from "./includes/CookieBanner";

window.$ = jQuery;

window.get_cookie = function(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return "";
};

window.set_cookie = function(cname, cvalue, expiry) {
    let date = new Date();
    date.setTime(date.getTime() + expiry);
    let expires = "expires=" + date.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.delete_cookie = function(cname) {
    window.set_cookie(cname, null, -1);
};

window.has_cookie = function(cname) {
    return window.get_cookie(cname) !== '';
};

$(document).ready(() => {
    let cookie_banner = new CookieBanner('#bcc-wrapper');
});
